<template>
  <div class="main">
    <headerpage></headerpage>
    <div class="box">
      <div class="container reg-login">
<!--      <div class="reg-login-img">-->
<!--        <img src="../assets/favicon.png" alt="图片">-->
<!--        <h1 style="-->
<!--				text-align: center;-->
<!--				color: #555;-->
<!--				margin-top: 5px;-->
<!--				margin-bottom: 5px;-->
<!--				font-weight: 600;-->
<!--			">{{ this.common.name }}</h1>-->
<!--      </div>-->
        <div v-if="status!=='reg'">
        <h1 style="
				text-align: center;
				color: #555;
				margin-top: 5px;
				margin-bottom: 5px;
				font-weight: 600;
			">用户登录</h1>
        <div style="
        font-size: 14px;
				text-align: center;
				color: #cb1414;
			">今起老用户续费，最高获赠100天会员！
        </div>
        <div style="
        font-size: 14px;
				text-align: center;
				color: #cb1414;
			">全球首发4KVR支持，推广好友即可抢先体验超高速率
        </div>
        <div class="sh_from">
          <div class="import import_name">
            <el-form label-width="50px" class="demo-ruleForm">
              <el-form-item label="账号:">
                <el-input name="username" placeholder="8位以上数字或字母" v-model="userInfo.username"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="import import_password">
            <el-form @submit.native.prevent label-width="50px" class="demo-ruleForm">
              <el-form-item label="密码:">
                <el-input type="password" placeholder="8位以上数字或字母" name="password" v-model="userInfo.password"
                          autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
          </div>

        </div>
        <div class="sh_btn_box">
          <input type="submit" class="sh_btn_full btn_sh" value="登录" @click="loginForm">
        </div>
        <!-- 注册引导 -->
        <div class="text-center mt-4">
          还没有账号？
          <a @click="$router.push({name:'login',params:{status:'reg'},query:{t:'reg'}})" class="w-100 primary-btn">立即注册</a>
        </div>
      </div>
      <div v-if="status==='reg'" class="sh_from sh_from_reg">
        <h1 style="
				text-align: center;
				color: #555;
				margin-bottom: 5px;
				font-weight: 600;
			">用户注册</h1>
        <div style="
				text-align: center;
				color: #cb1414;
			">新用户专享福利！订购一月会员，最高可获赠365天会员，超值体验，不容错过！
        </div>
        <div style="
				text-align: center;
				color: #A9A9A9;
				margin-bottom: 20px;
			">推广好友，即可长期免费使用{{ this.common.name }}
        </div>

        <div class="import import_name">
          <div class="inputbox">
            <div class="input">
              <input v-model="regInfo.username" value="" type="text" placeholder="6位以上数字或字母"
                     class="verification">
            </div>
          </div>
          <label class="label">用户名：</label>
          <p class="tip  error_username"></p>
          <!--可用（.tip_ture）or不可用（.tip_loser）-->
        </div>
        <div class="import import_password">
          <div class="inputbox">
            <div class="input">
              <input v-model="regInfo.password" type="password" placeholder="6位以上数字或字母" class="verification">
            </div>
          </div>
          <label class="label">登录密码：</label>
          <p class="tip  error_password"></p>
        </div>
        <div class="import import_password_agin">
          <div class="inputbox">
            <div class="input">
              <input v-model="regInfo.password_sub" type="password" placeholder="请重新输入密码" class="verification">
            </div>
          </div>
          <label class="label">重复密码：</label>
          <p class="tip  error_password_agin"></p>
          <!--可用（.tip_ture）or 两次输入不一致（.tip_loser）-->
        </div>
        <div class="import import_mail">
          <div class="inputbox">
            <div class="input">
              <input v-model="regInfo.email" type="text" placeholder="请输入正确邮箱地址，便于验证" class="verification">
            </div>
          </div>
          <label class="label">电子邮件：</label>
          <p class="tip  error_email"></p>
          <!--可用（.tip_ture）or不可用（.tip_loser）-->
          <input type="hidden" name="user_id" id="user_id" value="">
          <input type="hidden" id="promote_id" name="promote_id" value="0">

        </div>
        <div class="import import_email_code">
          <div class="inputbox">
            <div class="input">
              <input style="width: 50%;" value="" v-model="regInfo.code" type="text" placeholder="请输入邮箱验证码"
                     class="verification">
              <el-button icon="el-icon-message" @click="get_email_code" style="min-width: 35%;max-width: 50%"
                         type="primary" :disabled="disabled=!show">
                <span v-show="show">获取验证码</span>
                <span v-show="!show" class="count">{{ count }} s</span>
              </el-button>
            </div>
          </div>
          <label class="label">验证码：</label>
          <p class="tip  error_email_code"></p>
        </div>
        <div style="width: 100%;display: flex;justify-content: center">
          <el-button type="primary" style="width: 50%"  @click="regForm">注册</el-button>
        </div>
        <div style="
				text-align: center;
				color: #ccc;
			">建议使用常用邮箱，便于领取平台长期福利！
        </div>
      </div>
      </div>



<!--      <div :class="status!=='reg' ? 'sh_footer_fixed':'sh_footer'" id="sh_footer">-->
<!--&lt;!&ndash;        <img src="../assets/logo.jpg" style="width: auto;height: auto;zoom: 0.1;" alt="">&ndash;&gt;-->


<!--        <a class="power" :href="email">客服邮件： {{ this.common.email }}</a>-->

<!--        <div style="margin: 0 auto;width: 100%;text-align: center">-->
<!--          <a class="power" style="display: inline-block;" @click="$router.push({name:'answer'})"-->
<!--             target="_blank">关于我们</a>-->
<!--          &nbsp;&nbsp;-->
<!--          <a class="power" style="display: inline-block;" @click="$router.push({name:'privacy'})"-->
<!--             target="_blank">隐私政策</a>-->
<!--        </div>-->
<!--      </div>-->

    </div>

    <footerComponent :showbeian="false"></footerComponent>
  </div>
</template>

<script>
import axios from "axios";
import headerpage from "@/components/header";
import qs from "qs";
import {removeToken, setToken, setUser, setUserId} from "@/axios/token";
import footerComponent from "@/components/footer";

const TIME_COUNT = 60; //更改倒计时时间
export default {
  name: "loginPage",
  components: {headerpage, footerComponent},
  data() {
    return {
      show: true,  // 初始启用按钮
      count: '',   // 初始化次数
      timer: null,
      status: 'login',
      email: 'mailto:' + this.common.email,
      userInfo: {
        username: '',
        password: '',
      },
      regInfo: {
        promoteId: '',
        username: '',
        password: '',
        password_sub: '',
        email: '',
        code: '',
        code_token: '',
      },
      hasSpecialChars: false,
    }
  },
  created() {
    this.regInfo.promoteId = this.$route.query.promote_id || '';
    var status = this.$route.query.t;
    if (status === "reg") {
      this.status = "reg";
    } else {
      this.status = "login";
    }
  },
  methods: {
    goPage() {
      this.$router.push({name: 'user'})
    },
    hasSpecialChar(str) {
      return /[^a-zA-Z0-9]/.test(str);
    },
    async get_email_code() {
      //获取邮箱验证码
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.show = false;
        let data = {
          username: this.regInfo.username,
          email: this.regInfo.email
        }
        await this.axios.post('/user/getUserCode', qs.stringify(data)).then(resp => {
          if (resp.data.code === 0) {
            if (resp.data.data.code === 550) return this.$message({
              type: 'error',
              message: '获取验证码错误，请稍后再试!'
            })
            this.regInfo.code_token = resp.data.data.code_token
            this.$message({
              type: 'success',
              message: '验证码已发送!'
            })
          } else {
            this.$message({
              type: 'error',
              message: '获取验证码错误，请稍后再试!'
            })
          }
        });
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);  // 清除定时器
            this.timer = null;
          }
        }, 1000)
      }
    },
    loginForm() {
      if (this.userInfo.username.length < 6) {
        this.$message.error('用户名不小于6位字符');
        return false;
      }

      if (this.userInfo.username.length > 50) {
        this.$message.error('用户名不大于50位字符');
        return false;
      }

      if (this.userInfo.password.length === 0) {
        this.$message.error('用户名密码不能为空');
        return false;
      }

      this.axios.post('/user/login', qs.stringify(this.userInfo)).then(resp => {
        let rdata = resp.data
        if (rdata.code === 0) {
          this.$message.success(rdata.msg);
          setToken(rdata.data.token)
          setUser(rdata.data.user)
          setUserId(rdata.data.userid)
          this.$router.push("/user");
        } else {
          this.$message.error(rdata.msg);
        }
      }).catch(() => {
        this.$message.error('哦，请求出错');
      }).finally(() => {
            this.isLoading = false
          }
      );

    },
    regForm() {
      if (this.regInfo.username.length < 6) {
        this.$message.error('用户名不小于6位字符');
        return false;
      }

      if (this.regInfo.username.length > 50) {
        this.$message.error('用户名不大于50位字符');
        return false;
      }

      if (this.regInfo.password.length < 6) {
        this.$message.error('密码不小于6位字符');
        return false;
      }

      if (this.hasSpecialChar(this.regInfo.username)) {
        this.$message.error('用户名只能包含字母及阿拉伯数字');
        return false;
      }

      if (this.regInfo.email.length === 0) {
        this.$message.error('邮箱不能为空');
        return false;
      }
      if (this.regInfo.email.search(/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/) === -1) {
        this.$message.error('邮箱格式不正确');
        return false;
      }

      if (this.regInfo.password.length === 0) {
        this.$message.error('密码不能为空');
        return false;
      }

      if (this.regInfo.password != this.regInfo.password_sub) {
        this.$message.error('确认密码不一致请重新输入');
        return false;
      }

      if (this.regInfo.code.length != 4) {
        this.$message.error('验证码必须为四位字符');
        return false;
      }

      axios.post('/user/register', qs.stringify(this.regInfo)).then(resp => {
        var rdata = resp.data
        if (rdata.code === 0) {
          this.$message.success(rdata.msg);
          removeToken();
          this.$router.replace("/login");
        } else {
          this.$message.error(rdata.msg);
        }
      }).catch(() => {
        this.$message.error('哦，请求出错');
      }).finally(() => {
            this.isLoading = false
          }
      );
    },
  },
  watch: {
    '$route.params': {
      deep: true,
      immediate: true,
      handler(n) {
        if (n.status != 'reg') {
          this.status = 'login'
        } else {
          this.status = 'reg'
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
input {
  outline: none;
  border: none;
}

.reg-login {
  position: relative;
  top: 60px;
  border-radius: 8px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FFFFFF;
  box-shadow: 0px 8px 10px -6px rgba(0, 0, 0, 0.1),0px 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.reg-login-img {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;    /* 垂直居中 */
}

.el-button--primary {
  color: #FFF;
  background-color: #E74C3C;
  border-color: #E74C3C;
}

.main {
  /*background: #f2f3f5;*/
  width: 100vw;
  overflow: hidden;

  .box {
    max-width: 600px;
    min-height: 100vh;
    background: white;
    width: auto;
    margin: 0 auto;

    .sh_from {
      padding: 0 80px;
      margin-top: 0px;
      overflow: hidden;
    }

    .import {
      overflow: hidden;
      clear: both;
      border-bottom: 2px #edf1f2 solid;
      position: relative;
      margin-bottom: 20px;
    }

    .import .inputBox {
      float: left;
      width: 100%;
    }

    .import .inputBox .input {
      margin: 0 0 0 90px;
      overflow: hidden;
    }

    .import .inputBox .input input {
      padding: 0 10px 0 10px;
      width: 100%;
      font-size: 14px;
      line-height: 30px;
      height: 46px;
      background-color: white;
      color: #323232;
    }

    .import .label {
      width: 90px;
      height: 46px;
      line-height: 46px;
      font-size: 16px;

      text-align: right;
      float: left;
      margin-left: -100%;
      color: #555;
      cursor: pointer;
    }


    h2 {
      font-size: 21px
    }
  }

  .img {
    width: 100%;
    max-width: 600px;

    img {
      width: 100%;
    }
  }
}

.sh_footer_fixed {
  width: 250px;
  height: 320px;
  align-content: flex-end;
  align-items: center;
  justify-content: flex-end;
  margin: 0 auto;
}

.sh_footer {
  width: 250px;
  margin: 40px auto 0;
}

.sh_footer .logo_img,
.sh_footer_fixed .logo_img {
  width: 100%;
  height: 60px;
  background-size: auto 100%;
}

.sh_footer .power,
.sh_footer_fixed .power {
  font-size: 14px;
  color: #a2a2a2;
  text-align: center;
  margin-top: 10px;
  display: block;
}

#sh_footer {
  display: flex;
  flex-direction: column;
}

.sh_btn_box {
  margin-top: 20px;
  padding: 0 140px;
}

.sh_btn_box .sh_btn_full {
  font-size: 16px;
  line-height: 30px;
  border-radius: 5px !important;
}

.sh_btn_box .sh_btn_full:nth-child(2) {
  margin-top: 20px;
}

.sh_btn_box .btn_sh {
  color: #fff;
  background-color: #E74C3C;
  border-color: #2d8eff;
  transition: background-color 2s;
  -moz-transition: background-color 2s;
  -webkit-transition: background-color 2s;
  -o-transition: background-color 2s;
  width: 100%;

}

.sh_btn_box .btn_sh:hover {
  color: #fff;
  background-color: #E74C3C;
  border-color: #2d8eff;
}

.sh_from_reg {
  /*页面内容（注册）*/


  .sh_tips .tips {
    text-align: center;
    font-size: 14px;
    color: #323232;
  }

  .sh_from {
    padding: 0 80px;
    margin-top: 0px;
    overflow: hidden;
  }

  .import {
    overflow: hidden;
    clear: both;
    border-bottom: 2px #edf1f2 solid;
    position: relative;
    margin-bottom: 20px;
  }

  .import .inputbox {
    float: left;
    width: 100%;
  }

  .import .inputbox .input {
    margin: 0 0 0 90px;
    overflow: hidden;
  }

  .import .inputbox .input input {
    padding: 0 10px 0 10px;
    width: 100%;
    font-size: 14px;
    line-height: 30px;
    height: 46px;
    background-color: transparent;
    color: #323232;
  }

  .import .label {
    width: 90px;
    height: 46px;
    line-height: 46px;
    font-size: 16px;

    text-align: right;
    float: left;
    margin-left: -100%;
    color: #555;
    cursor: pointer;
  }

  .import .tip {
    font-size: 12px;
    position: absolute;
    right: 0;
    top: 12px;
    line-height: 20px;
    display: inline-block;
    cursor: Default;
  }

  .import .tip_ture {
    color: #6dc873;
  }

  .import .tip_loser {
    color: #ee696c;
  }

  .sh_btn_box {
    margin-top: 20px;
    padding: 0 140px;
  }

  .sh_btn_box .sh_btn_full {
    font-size: 16px;
    line-height: 30px;
  }

  .sh_btn_box .sh_btn_full:nth-child(2) {
    margin-top: 20px;
  }

  .sh_btn_box .btn_sh {
    color: #fff;
    background-color: #E74C3C;
    border-color: #2d8eff;
    transition: background-color 2s;
    -moz-transition: background-color 2s;
    -webkit-transition: background-color 2s;
    -o-transition: background-color 2s;
    width: 100%;

  }

  .sh_btn_box .btn_sh:hover {
    color: #fff;
    background-color: #E74C3C;
    border-color: #2d8eff;
  }

  .sh_co_header img {
    display: block;
    width: 100%;
    height: auto;
  }

  .sh_co_head {
    overflow: hidden;
  }

  .sh_co_head .title {
    background: #3586ff;
    padding: 40px 20px 30px 20px;
  }

  .sh_co_head .title p {
    font-size: 20px;
    text-align: center;
    color: #fff;
  }

  .sh_app {
    padding: 80px 120px 0 120px;
  }

  .sh_app .li {
    padding: 16px 20px;
    background: #e8edf5;
    border: #dde2eb 1px solid;
    -moz-border-radius: 6px;
    -webkit-border-radius: 6px;
    border-radius: 6px;
    display: block;
    float: none;
    cursor: pointer;

    transition: background-color 2s, border-color 2s;
    -moz-transition: background-color 2s, border-color 2s;
    -webkit-transition: background-color 2s, border-color 2s;
    -o-transition: background-color 2s, border-color 2s;
  }

  .sh_app li .box {
    display: block;
    text-decoration: none;
  }

  .sh_app li .box .text {
    display: inline-block;
    padding-left: 18px;
  }

  .sh_app li .box .text .tx01 {
    font-size: 16px;
    color: #1d2b40;
    line-height: 20px;
  }

  .sh_app li .box .text .tx02 {
    font-size: 12px;
    color: #2773e4;
    line-height: 20px;
    margin-top: 6px;
  }

  .sh_app li .tip {
    font-size: 14px;
    margin-top: 10px;
    text-align: center;
    color: #a2a2a2;
    line-height: 16px;
  }
}

@media (max-width: 480px) {
  .sh_from {
    padding: 0 40px !important;
  }
}

@media (max-width: 300px) {
  .sh_from {
    padding: 0 !important;
  }
}
</style>

<!--<style scoped>.reg-login {-->
<!--  position: relative;-->
<!--  top: 30px;-->
<!--  border-radius: 8px;-->
<!--  background: linear-gradient(0deg, rgba(0, 0, 0, 0.001), rgba(0, 0, 0, 0.001)), #FFFFFF;-->
<!--  box-shadow: 0px 8px 10px -6px rgba(0, 0, 0, 0.1), 0px 20px 25px -5px rgba(0, 0, 0, 0.1);-->
<!--  overflow-y: auto; /* 允许内容滚动 */-->
<!--}-->

<!--@media (max-width: 600px) {-->
<!--  .reg-login {-->
<!--    top: 20px; /* 调整顶部位置 */-->
<!--    overflow-y: auto; /* 允许内容滚动 */-->
<!--  }-->
<!--}-->
<!--</style>-->